__turbopack_context__.v({
  "animate": "jqH2Za_animate",
  "avatar": "jqH2Za_avatar",
  "card": "jqH2Za_card",
  "circle": "jqH2Za_circle",
  "line": "jqH2Za_line",
  "rect": "jqH2Za_rect",
  "root": "jqH2Za_root",
  "shimmer": "jqH2Za_shimmer",
  "srOnly": "jqH2Za_srOnly",
  "static": "jqH2Za_static",
  "text": "jqH2Za_text",
});
